<template>
  <v-checkbox v-model="value" @change="changeTimer" :label="labelComputed">Auto Refresh</v-checkbox>
</template>

<script>
export default {
  props: ["interval", "checked", "tickOnSet", "label", "showIntervalTime"],
  data() {
    return {
      value: false,
      intervalHandle: {}
    };
  },
  computed: {
    labelComputed: function() {
      let label = "";
      if (typeof this.label !== "undefined") label = this.label;
      label =
        label +
        (this.showIntervalTime ? " (every " + this.interval + " seconds)" : "");
      return label;
    }
  },
  mounted() {
    if (typeof this.checked !== "undefined") this.value = this.checked;
    this.changeTimer();
  },
  methods: {
    onTick() {
      this.$emit("tick");
    },
    changeTimer() {
      if (this.value) {
        if (this.tickOnSet) this.onTick;
        this.intervalHandle = setInterval(this.onTick, this.interval * 1000);
      } else {
        clearInterval(this.intervalHandle);
      }
    }
  }
};
</script>